import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import 'reflect-metadata';
import { NoProviderMetadataError } from '../errors';
import { Scope } from '../injection-context';
export var Reflector = /*#__PURE__*/function () {
  function Reflector() {
    _classCallCheck(this, Reflector);
  }

  _createClass(Reflector, null, [{
    key: "addModuleMetadata",
    value: function addModuleMetadata(target, metadata) {
      var withDefaults = _objectSpread({
        providers: [],
        imports: [],
        exports: []
      }, metadata);

      Reflect.defineMetadata('self:module', withDefaults, target);
    }
  }, {
    key: "getModuleMetadata",
    value: function getModuleMetadata(metatype) {
      return Reflect.getMetadata('self:module', metatype);
    }
  }, {
    key: "addProviderMetadata",
    value: function addProviderMetadata(metatype, metadata) {
      var withDefaults = _objectSpread({
        scope: Scope.SINGLETON
      }, metadata !== null && metadata !== void 0 ? metadata : {});

      Reflect.defineMetadata('self:provider', withDefaults, metatype);
    }
  }, {
    key: "getProviderMetadata",
    value: function getProviderMetadata(metatype) {
      var metadata = Reflect.getMetadata('self:provider', metatype);

      if (metadata == null) {
        throw new NoProviderMetadataError(metatype.name);
      }

      return metadata;
    }
  }, {
    key: "getConstructorDependencies",
    value: function getConstructorDependencies(metatype) {
      var _Reflect$getMetadata;

      if (metatype == null) {
        return [];
      }

      var dependencies = (_Reflect$getMetadata = Reflect.getMetadata('design:paramtypes', metatype)) !== null && _Reflect$getMetadata !== void 0 ? _Reflect$getMetadata : [];
      var manualDependencies = Reflector.getManuallyInjectedDeps(metatype);
      manualDependencies.forEach(function (dep) {
        return dependencies[dep.index] = dep.token;
      });
      return dependencies;
    }
  }, {
    key: "addManuallyInjectedDeps",
    value: function addManuallyInjectedDeps(target, dependencies) {
      var existing = Reflector.getManuallyInjectedDeps(target);
      Reflect.defineMetadata('self:paramtypes', [].concat(_toConsumableArray(existing), _toConsumableArray(dependencies)), target);
    }
  }, {
    key: "getManuallyInjectedDeps",
    value: function getManuallyInjectedDeps(target) {
      var _Reflect$getMetadata2;

      return (_Reflect$getMetadata2 = Reflect.getMetadata('self:paramtypes', target)) !== null && _Reflect$getMetadata2 !== void 0 ? _Reflect$getMetadata2 : [];
    }
  }]);

  return Reflector;
}();